import { render } from "./LegacyButton.vue?vue&type=template&id=0f0cfc6f&scoped=true"
import script from "./LegacyButton.vue?vue&type=script&lang=js"
export * from "./LegacyButton.vue?vue&type=script&lang=js"

import "./LegacyButton.vue?vue&type=style&index=0&id=0f0cfc6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0cfc6f"]])

export default __exports__